module.exports = __webpack_public_path__ + "static/media/ES.a62a83f3.svg";